import React from 'react';
import { toast } from 'react-hot-toast';
import {
  approveJoinRequest,
  denyJoinRequest,
  pendingJoinRequests,
} from '../../services/joinRequests';
import { describeError } from '../../utils/errorLog';

export default function JoinRequestsPanel({ eventId, hostId, requests, onResolved }) {
  const pending = pendingJoinRequests(requests);
  const [busyUid, setBusyUid] = React.useState(null);

  if (pending.length === 0) return null;

  const resolve = async (request, action) => {
    setBusyUid(request.uid);
    try {
      if (action === 'allow') {
        await approveJoinRequest({ eventId, request, hostId });
        toast.success(`${request.name || 'Guest'} can join`);
      } else {
        await denyJoinRequest({ eventId, uid: request.uid, hostId });
        toast.success(`Declined ${request.name || 'guest'}`);
      }
      onResolved?.();
    } catch (error) {
      console.error('Failed to resolve join request:', describeError(error));
      toast.error(error?.code === 'event-ended'
        ? 'This party has ended'
        : 'Could not update that request');
    } finally {
      setBusyUid(null);
    }
  };

  return (
    <section
      className="border-b border-gray-800 bg-black/40 px-4 py-3 md:px-6"
      data-testid="join-requests-panel"
    >
      <p className="mb-2 text-xs uppercase tracking-wide text-amber-400">
        Waiting to join ({pending.length})
      </p>
      <ul className="space-y-2">
        {pending.map((request) => (
          <li
            key={request.uid}
            className="flex items-center gap-3 rounded-lg bg-white/5 px-3 py-2"
          >
            <span className="min-w-0 flex-1 truncate text-sm text-white">
              {request.name || 'Guest'}
            </span>
            <button
              type="button"
              disabled={busyUid === request.uid}
              onClick={() => resolve(request, 'allow')}
              className="rounded-lg bg-blue-600 px-3 py-1.5 text-xs text-white hover:bg-blue-700 disabled:opacity-60"
            >
              Allow
            </button>
            <button
              type="button"
              disabled={busyUid === request.uid}
              onClick={() => resolve(request, 'deny')}
              className="rounded-lg bg-white/10 px-3 py-1.5 text-xs text-white hover:bg-white/20 disabled:opacity-60"
            >
              Deny
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
